export default __webpack_public_path__ + "static/media/FI_Co-fundedbytheEU_RGB_NEG.5c2f953d.png";